// extracted by mini-css-extract-plugin
module.exports = {"profile_btn":"ViewProfile_profile_btn__3xu-u","edit_btn":"ViewProfile_edit_btn__sCux2","password_btn":"ViewProfile_password_btn__1_yfn"};